export default __webpack_public_path__ + "static/media/icn_upload_inventory.103e26c7.svg";